<template>
  <div>
    <div v-for="material in cartMaterials" :key="material.id" @click="selectMaterial(material)" :class="{ active: material.id === selectedMaterial }" class="card card-material">
      <div class="card-body">
        <div class="title-row">
          {{ material.filterFirst }}<template v-if="material.bruto"> (bruto persplaat)</template><br/>
          <template v-if="isHPL(material)">{{ materialType(material) }}<br/></template>
          <template v-else>{{ materialType(material) }}<br/></template>
          <template v-if="material.product">{{ material.total_thickness }} mm</template>

          <template v-if="cartMaterials.length > 1">
            <div v-on:click.stop.prevent="deleteMaterial(material)" :class="{ active: material.id === selectedMaterial }" class="material-trash float-right">
              <span v-b-tooltip.hover.d200 title="Verwijderen">
                <font-awesome-icon class="font-awesome-icon" icon="trash-alt"/>
              </span>
            </div>
          </template>
        </div>

        <div class="material-row">
          {{ panelcount(material) }}
          <template v-if="panelcount(material) === 1 && !material.bruto"> paneel</template>
          <template v-else-if="panelcount(material) > 1 && !material.bruto"> panelen</template>
          <template v-else-if="panelcount(material) === 1 && material.bruto"> plaat</template>
          <template v-else-if="panelcount(material) > 1 && material.bruto"> platen</template>

          <span v-if="showSawingSchedule(material)" v-on:click.stop.prevent="openSawingSchedule(material.id)" :class="{ active: material.id === selectedMaterial }" class="sawing-schedule float-right">
            Zaagschema
          </span>
        </div>
      </div>
    </div>

    <div class="mt-3">
      <button @click="addMaterial" class="btn btn-outline-oldevuuren w-100 btn-round">
        <font-awesome-icon class="font-awesome-icon" icon="plus-circle"/>
        Materiaal toevoegen
      </button>
    </div>

<!--    <div class="mt-3 m-2 p-2 restmaterial">-->
<!--      <div class="mb-2">Restmateriaal wordt niet standaard meegeleverd.</div>-->
<!--      <div class="mb-2">Onze productie afdeling gebruikt naar eigen inzicht het restmateriaal voor het zo optimaal mogelijk verpakken van de panelen om beschadigingen bij transport te voorkomen.</div>-->
<!--      <div>Wil je restmateriaal meegeleverd krijgen, dan dien je dit als een los paneel in te voeren.</div>-->
<!--    </div>-->

    <b-modal ref="delete-material-modal" id="delete-material-modal" footer-class="modal-footer modal-delete-material" size="sm" centered>
      <template slot="modal-header">
        <h4 class="modal-title">Let op!</h4>
        <button type="button" aria-label="Close" @click="hideModal" class="close">
          <font-awesome-icon class="font-awesome-icon" icon="times-circle"/>
        </button>
      </template>
      <template slot="default">
        <div class="col-md-13">
          Weet je zeker dat je dit materiaal wilt verwijderen?
        </div>
      </template>

      <template slot="modal-footer">
        <button
          @click="hideModal"
          type="button"
          class="btn btn-round">Annuleren
        </button>
        <button
          @click="confirmDeleteMaterial"
          type="button"
          class="btn btn-oldevuuren btn-round">Verwijderen
        </button>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { SELECT_MATERIAL, ADD_MATERIAL, REMOVE_MATERIAL } from '../../../store/types'
  import { orderValidation } from '../../../mixins/order-validation'

  export default {
    data() {
      return {
        saved: false,
        materialToDelete: null
      }
    },
    mixins: [orderValidation],
    computed: {
      currentMaterial() {
        return !this.$store.getters.material ? false : this.$store.getters.material
      },
      selectedMaterial() {
        return !this.$store.getters.selectedMaterial ? false : this.$store.getters.selectedMaterial
      },
      cartMaterials() {
        return !this.$store.getters.cartMaterials ? [] : this.$store.getters.cartMaterials
      }
    },
    methods: {
      showSawingSchedule(material) {
        if (material.bruto) {
          return false
        }
        return material.filterDeliveryProgram ? material.filterDeliveryProgram.indexOf('Meubelpanelen') === -1 : false
      },
      openSawingSchedule(materialId) {
        // Only show if no errors
        if (this.validateMaterial(this.currentMaterial)) {
          this.$emit('openSawingSchedule', materialId)
        }
      },
      panelcount(material) {
        let total = 0
        material.panels.forEach(function(panel) {
          total += panel.amount ? parseInt(panel.amount) : 0
        })
        return !total ? 0 : total
      },
      isHPL(material) {
        return material.filterFirst ? material.filterFirst.indexOf('HPL') !== -1 : false
      },
      materialType(material) {
        if (material.thickness) {
          if (this.isHPL(material)) {
            let label1 = material.side1 ? ' / ' + material.side1.label : ''
            let label2 = material.side2 ? ' / ' + material.side2.label : ''
            return material.filterSecond + label1 + label2
          } else {
            return material.filterThird === 'geen' ? material.filterSecond : material.filterThird
          }
        }
        return ''
      },
      addMaterial() {
        // Only add new material if no errors
        if (this.validateMaterial(this.currentMaterial)) {
          this.$store.dispatch(ADD_MATERIAL)
        }
      },
      selectMaterial(material) {
        // If clicked on the current material, just do nothing...
        if (this.selectedMaterial !== material.id) {
          // Only select material if current material is valid
          if (this.validateMaterial(this.currentMaterial)) {
            this.$store.dispatch(SELECT_MATERIAL, material)
          }
        }
      },
      deleteMaterial(material) {
        this.materialToDelete = material
        this.$refs['delete-material-modal'].show()
      },
      confirmDeleteMaterial() {
        this.$store.dispatch(REMOVE_MATERIAL, this.materialToDelete)
        this.hideModal()
      },
      hideModal() {
        this.$refs['delete-material-modal'].hide()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .card-material {
    color: $dark-grey;
    cursor: pointer;

    &:hover {
      border: 1px solid $dark-grey;
      border-radius: 0.25rem;

      color: $black;

      // Show zaagschema & trash

      .sawing-schedule, .material-trash {
        visibility: visible;
      }
    }

    &.active {
      border: 1px solid $oldevuuren-blue;
      border-radius: 0.25rem;

      color: $black;
    }
  }

  .restmaterial {
    border: 1px solid #db1464;
    border-radius: 0.25rem;
    font-size: 0.8rem;
  }

  .title-row {
    font-weight: bold;

    .label {
      font-weight: normal;
    }

    .material-trash {
      color: $light-grey;
      cursor: pointer;
      visibility: hidden;

      :hover {
        color: $black;
      }

      &.active {
        visibility: visible;
      }
    }
  }

  .description-row {
    font-weight: bold;
  }

  .material-row {
    color: $light-grey;

    :hover {
      color: $black;
    }

    .sawing-schedule {
      cursor: pointer;
      visibility: hidden;

      &.active {
        color: $oldevuuren-blue;
        visibility: visible;

        &:hover {
          color: $oldevuuren-darkblue;
        }
      }
    }
  }

  .router-link {
    text-decoration: underline;
  }
</style>
